export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const buildUrl = (endpoint, params = {}) => {
  const base = `${API_BASE_URL}${endpoint}`;
  const url = new URL(base);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.append(key, value);
    }
  });

  return url.toString();
};
export const postJson = async (endpoint, body = {}, { params = {}, headers = {}, includeCredentials = false } = {}) => {
  const url = buildUrl(endpoint, params);

  const fetchOptions = {
    method: "POST",
    headers: {
      "Accept": "*/*",
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify(body),
  };

  if (includeCredentials) {
    fetchOptions.credentials = "include"; 
  }

  const res = await fetch(url, fetchOptions);

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Request failed: ${res.status} ${res.statusText}`);
    err.status = res.status;
    err.body = text;
    throw err;
  }


  const text = await res.text();
  return text ? JSON.parse(text) : null;
};
export const getJson = async (endpoint, { params = {}, headers = {}, includeCredentials = false } = {}) => {
  const url = buildUrl(endpoint, params);

  const fetchOptions = {
    method: "GET",
    headers: {
      "Accept": "*/*",
      ...headers,
    },
  };

  if (includeCredentials) {
    fetchOptions.credentials = "include"; 
  }

  const res = await fetch(url, fetchOptions);

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Request failed: ${res.status} ${res.statusText}`);
    err.status = res.status;
    err.body = text;
    throw err;
  }

  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

